import { createModalHook } from '../../hooks/useModal'

export const useEditAddressModal = createModalHook()
